import React from 'react'
import PropTypes from 'prop-types'
import numeral from "../../../helpers/numeral";


const Currency = ({value}) => {
    return value + '' == '0.00'  ? 'Grátis' : numeral(parseFloat(value)).format('$ 0,0.00')
}

Currency.propTypes = {
    value: PropTypes.number.isRequired
}



export default Currency



// WEBPACK FOOTER //
// ./src/components/_common/Currency/index.js